module.exports = "pegasus_template/assets/theme6/main-bg.jpg";